import { useEffect, useState } from "react";
import { Play, X } from "lucide-react";
import { Reveal } from "./Reveal";
import { VIDEO_TILES } from "../data/content";

export const VideoWorks = () => {
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!active) return;
    const onKey = (e) => e.key === "Escape" && setActive(null);
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [active]);

  return (
    <section className="section section-dark" id="video" data-testid="video-section">
      <div className="wrap">
        <Reveal className="section-head">
          <span className="eyebrow"><span className="sq" /> Video Works</span>
          <h2 data-testid="video-heading">Motion that tells a story.</h2>
          <p>Bringing brands to life beyond static visuals — brand films, commercials, AI-generated video,
            motion graphics and more.</p>
        </Reveal>
        <Reveal delay={100}>
          <div className="video-grid" data-testid="video-grid">
            {VIDEO_TILES.map((v) => (
              <button
                className="video-tile"
                key={v.label}
                onClick={() => setActive(v)}
                data-testid={`video-tile-${v.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                aria-label={`Play ${v.label}`}
              >
                <img src={v.img} alt={v.label} loading="lazy" width="1920" height="1080" />
                <div className="overlay">
                  <div className="play-btn"><Play size={20} fill="currentColor" strokeWidth={0} /></div>
                  <h4>{v.label}</h4>
                </div>
              </button>
            ))}
          </div>
        </Reveal>
      </div>

      {active && (
        <div className="lightbox" onClick={() => setActive(null)} data-testid="video-modal" role="dialog" aria-modal="true">
          <button className="lightbox-close" aria-label="Close" onClick={() => setActive(null)} data-testid="video-modal-close">
            <X size={26} />
          </button>
          <div className="video-modal-box" onClick={(e) => e.stopPropagation()}>
            {active.url ? (
              <video src={active.url} poster={active.img} controls autoPlay preload="metadata" data-testid="video-player" />
            ) : (
              <div className="video-placeholder" data-testid="video-placeholder">
                <div className="play-btn big"><Play size={26} fill="currentColor" strokeWidth={0} /></div>
                <h3>{active.label}</h3>
                <p>Video showreel for this category is being added — check back soon.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};
